import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import * as R from 'ramda';
import { FilterTestIds } from '../../../../utils/testIds/Filter.testIds';
import { DrawerProps, FilterStep } from '../../filter.types';
import FilterOptionList from '../Filter/FilterOptionList';
import FilterSelectedOptionList from '../Filter/FilterSelectedOptionList';
import ToolbarPopover from '../ToolbarPopover/ToolbarPopover';

const FilterPopover = ({
  anchorEl,
  handleClosePopover,
  menu,
  options,
  handleSelectFilter,
  list,
  onClickBack,
}: DrawerProps) => {
  const isFirstStep = menu.step === FilterStep.FIRST_STEP;
  const selectedOption = R.isNil(menu.filterIndex) ? undefined : options[menu.filterIndex];

  return (
    <ToolbarPopover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={handleClosePopover}
      testId={FilterTestIds.WRAPPER}
      width={325}
      paperSx={(theme) => ({
        maxHeight: '500px',
        maxWidth: 'calc(100vw - 32px)',
        padding: theme.spacing(1.25, 0, 0.5, 0),
      })}
    >
      <Fade in appear key={isFirstStep ? 'list' : 'selected'}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 auto',
            minHeight: 0,
            minWidth: 0,
            overflowX: 'hidden',
            overflowY: isFirstStep ? 'auto' : 'hidden',
            width: '100%',
            '& .MuiListItemButton-root, & .MuiListItem-root': {
              minWidth: 0,
            },
            '& .MuiListItemButton-root .MuiTypography-root, & .MuiListItem-root .MuiTypography-root':
              {
                display: 'block',
                minWidth: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
          }}
        >
          {isFirstStep ? (
            <FilterOptionList options={options} onClick={handleSelectFilter} />
          ) : (
            selectedOption && (
              <FilterSelectedOptionList
                onClickBack={onClickBack}
                list={list}
                onClickApply={handleClosePopover}
                option={selectedOption}
                canReturnToFilterList={menu.enableReturnToList}
              />
            )
          )}
        </Box>
      </Fade>
    </ToolbarPopover>
  );
};

export default FilterPopover;
